import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// mui components
import {
    Paper,
    Divider,
    styled,
    Grid,
    Box,
    Button,
    Modal,
    Typography,
    TextField,
    Card,
    CardHeader,
    CardContent
} from "@mui/material";
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '94%', sm: 700, md: 800 },
    maxHeight: '90vh',
    overflowY: 'auto',
    outline: 'none',
    border: 'none',
    boxSizing: 'border-box'
};

// Standard corporate outliner dictionary configuring premium input layouts
const enterpriseInputStyles = {
    width: '100%',
    '& .MuiOutlinedInput-root': {
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        transition: 'all 0.2s ease-in-out',
        border: '1px solid #E2E8F0',
        '& fieldset': { border: 'none' },
        '&:hover': {
            borderColor: '#CBD5E1',
            boxShadow: '0 2px 8px rgba(0,0,0,0.02)'
        },
        '&.Mui-focused': {
            borderColor: '#1976d2',
            boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
        }
    },
    '& .MuiInputLabel-outlined': {
        color: '#64748B',
        fontWeight: 500,
        transform: 'translate(14px, 10px) scale(1)',
        '&.Mui-focused, &.MuiInputLabel-shrink': {
            transform: 'translate(14px, -8px) scale(0.75)',
            color: '#1976d2',
            fontWeight: 600
        }
    },
    '& input, & .MuiSelect-select': {
        padding: '10px 14px !important',
        fontSize: '13.5px',
        color: '#1E293B',
        fontWeight: 500
    },
    '& .MuiFormHelperText-root': {
        mx: 0.5,
        mt: 0.75,
        fontWeight: 500
    }
};

const AddPickup = ({ addPickupItemVisible, onAddPickupModalClose, formDataHandler, onAddPickupItemClick, addPickupItemData, editPickupItemId,handlePackageDimensionInputChange, errors }) => {
    const box = useSelector(state => state.box);

    return (
        <>
            <Modal
                open={addPickupItemVisible}
                onClose={onAddPickupModalClose}
                closeAfterTransition
            >
                <Box sx={modalStyle}>
                    <Card 
                        sx={{ 
                            backgroundColor: '#FFFFFF',
                            borderRadius: '16px',
                            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                            border: '1px solid #E2E8F0',
                            overflow: 'hidden'
                        }} 
                        className="sc--cardhead--details"
                    >
                        <CardHeader 
                            title={
                                <Typography variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px' }}>
                                    {(editPickupItemId != "") ? "Edit Package" : "Add Package"}
                                </Typography>
                            }
                            sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                        />
                        <Divider sx={{ borderColor: '#E2E8F0' }} />
                        <CardContent sx={{ p: 4, boxSizing: 'border-box' }}>
                            <Grid container spacing={3}>
                                
                                {/* Choose Measurement Dropdown Selector Block */}
                                <Grid item xs={12}>
                                    <Box sx={{ minHeight: '40px' }}>
                                        <FormControl fullWidth variant="outlined" size="small">
                                            <InputLabel id="measurement-select-outlined-label" sx={enterpriseInputStyles['& .MuiInputLabel-outlined']}>Choose Measurement</InputLabel>
                                            <Select
                                                labelId="measurement-select-outlined-label"
                                                id="demo-simple-select-standard"
                                                name="choosenmeasurement"
                                                value={addPickupItemData.choosemeasurement}
                                                onChange={(event) => {
                                                    handlePackageDimensionInputChange(event)
                                                }}
                                                label="Choose Measurement"
                                                sx={enterpriseInputStyles['& .MuiOutlinedInput-root']}
                                            >
                                                {box && box.data && box.data.map((item) => {
                                                    if(item && typeof item.hide=='undefined'){
                                                    return (
                                                        <MenuItem value={item._id} key={item._id} sx={{ py: 1, borderBottom: '1px solid #F1F5F9' }}>
                                                            <Typography variant="body2" sx={{ margin: 'unset', color: '#334155', fontWeight: 500 }}>
                                                                {item.box_name}(
                                                                {item.box_length}{item.box_length_unit} <Box component="span" sx={{ color: '#1976d2', fontWeight: 700 }}> x </Box>
                                                                {item.box_width}{item.box_width_unit} <Box component="span" sx={{ color: '#1976d2', fontWeight: 700 }}> x </Box>
                                                                {item.box_height}{item.box_height_unit}<span>, </span>
                                                                {item.box_weight}{item.box_weight_unit})
                                                            </Typography>
                                                        </MenuItem>
                                                    )
                                                    }
                                                })}
                                                <MenuItem value={0} sx={{ py: 1, fontWeight: 600, color: '#0F172A' }}>Custom</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid>

                                {/* Volumetric Metric Grid: Length, Width, Height, and Dimension Unit */}
                                <Grid item xs={12} sm={3}>
                                    <Box sx={{ minHeight: '40px' }}>
                                        <TextField
                                            label="Length"
                                            type='number'
                                            name="length"
                                            size="small"
                                            inputProps={{ min: 1 }}
                                            value={addPickupItemData.length}
                                            onChange={formDataHandler}
                                            error={!!errors.length}
                                            helperText={errors.length}
                                            variant="outlined"
                                            sx={enterpriseInputStyles}
                                        />
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={3}>
                                    <Box sx={{ minHeight: '40px' }}>
                                        <TextField
                                            label="Width"
                                            name="width"
                                            type='number'
                                            size="small"
                                            inputProps={{ min: 1 }}
                                            value={addPickupItemData.width}
                                            onChange={formDataHandler}
                                            error={!!errors.width}
                                            helperText={errors.width}
                                            variant="outlined"
                                            sx={enterpriseInputStyles}
                                        />
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={3}>
                                    <Box sx={{ minHeight: '40px' }}>
                                         <TextField
                                            label="Height"
                                            name="height"
                                            type='number'
                                            size="small"
                                            inputProps={{ min: 1 }}
                                            value={addPickupItemData.height}
                                            onChange={formDataHandler}
                                            error={!!errors.height}
                                            helperText={errors.height}
                                            variant="outlined"
                                            sx={enterpriseInputStyles}
                                        />
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={3}>
                                    <Box sx={{ minHeight: '40px' }}>
                                         <FormControl fullWidth variant="outlined" size="small" error={!!errors.dimension_unit}>
                                            <InputLabel id="dim-unit-outlined-label" sx={enterpriseInputStyles['& .MuiInputLabel-outlined']}>Dimension Unit</InputLabel>
                                            <Select
                                                labelId="dim-unit-outlined-label"
                                                id="demo-simple-select-error"
                                                name="dimension_unit"
                                                value={addPickupItemData.dimension_unit}
                                                onChange={formDataHandler}
                                                label="Dimension Unit"
                                                sx={enterpriseInputStyles['& .MuiOutlinedInput-root']}
                                            >
                                                <MenuItem value={"in"}>in</MenuItem>
                                                <MenuItem value={"cm"}>cm</MenuItem>
                                            </Select>
                                            {errors.dimension_unit && <FormHelperText sx={enterpriseInputStyles['& .MuiFormHelperText-root']}>{errors.dimension_unit}</FormHelperText>}
                                        </FormControl>
                                    </Box>
                                </Grid>

                                {/* Mass, Scaling, and Product Volume Parameters Row */}
                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ minHeight: '40px' }}>
                                        <TextField
                                            label="Weight"
                                            name="weight"
                                            type='number'
                                            size="small"
                                            inputProps={{ min: 1 }}
                                            value={addPickupItemData.weight}
                                            onChange={formDataHandler}
                                            error={!!errors.weight}
                                            helperText={errors.weight}
                                            variant="outlined"
                                            sx={enterpriseInputStyles}
                                        />
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ minHeight: '40px' }}>
                                        <FormControl fullWidth variant="outlined" size="small" error={!!errors.weight_unit}>
                                            <InputLabel id="weight-unit-outlined-label" sx={enterpriseInputStyles['& .MuiInputLabel-outlined']}>Weight Unit</InputLabel>
                                            <Select
                                                labelId="weight-unit-outlined-label"
                                                id="demo-simple-select-error"
                                                name="weight_unit"
                                                value={addPickupItemData.weight_unit}
                                                onChange={formDataHandler}
                                                label="Weight Unit"
                                                sx={enterpriseInputStyles['& .MuiOutlinedInput-root']}
                                            >
                                                <MenuItem value={"kg"}>kg</MenuItem>
                                                <MenuItem value={"lb"}>lb</MenuItem>
                                            </Select>
                                            {errors.weight_unit && <FormHelperText sx={enterpriseInputStyles['& .MuiFormHelperText-root']}>{errors.weight_unit}</FormHelperText>}
                                        </FormControl>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Box sx={{ minHeight: '40px' }}>
                                        <TextField
                                            label="Quantity"
                                            name="quantity"
                                            type='number'
                                            size="small"
                                            inputProps={{ min: 1 }}
                                            value={addPickupItemData.quantity}
                                            onChange={formDataHandler}
                                            error={!!errors.quantity}
                                            helperText={errors.quantity}
                                            variant="outlined"
                                            sx={enterpriseInputStyles}
                                        />
                                    </Box>
                                </Grid>

                                {/* Action Buttons Panel Toolbar Footer */}
                                <Grid item xs={12}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', pt: 2, borderTop: '1px solid #E2E8F0', mt: 1 }}>
                                        <Button
                                            variant="contained"
                                            onClick={onAddPickupItemClick}
                                            sx={{
                                                textTransform: 'none',
                                                borderRadius: '10px',
                                                fontWeight: 700,
                                                fontSize: '13.5px',
                                                height: '38px',
                                                px: 4,
                                                boxShadow: 'none',
                                                backgroundColor: '#1976d2',
                                                color: '#FFFFFF',
                                                '&:hover': { backgroundColor: '#115293', boxShadow: 'none' }
                                            }}
                                        >
                                            {(editPickupItemId != "") ? "Save" : "Save"}
                                        </Button>
                                    </Box>
                                </Grid>

                            </Grid>
                        </CardContent>
                    </Card>
                </Box>
            </Modal>
        </>
    )
}

export default AddPickup;